import { Footer } from '@/components/footer';
import Navbar from '@/components/navbar/navbar';
import { Sidebar } from '@/components/sidebar';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

export const MainLayout = () => {
  return (
    <ProtectedRoute>
      <div className="flex min-h-screen w-screen overflow-hidden bg-background">
        <Sidebar />
        <div className="flex h-full w-full flex-col bg-background">
          <Navbar />
          <ScrollArea
            variant="light"
            className="h-[calc(100vh-88px)] w-full bg-background"
          >
            <div className="flex min-h-[calc(100vh-88px)] flex-col">
              <div className="flex-1">
                <Outlet />
              </div>
              <Footer />
            </div>
          </ScrollArea>
        </div>
      </div>
    </ProtectedRoute>
  );
};
